import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'app/models/user';
import swal from "bootstrap-sweetalert";
import { UserService } from 'app/services/user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { UserCreateComponent } from '../create/user-create.component';
import { UserUpdateComponent } from '../update/user-update.component';

@Component({
  templateUrl: './user-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserListComponent implements OnInit, OnDestroy {

  constructor(
    private _userService: UserService,
    private _changeDetector: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService
    ) { }

  private _users: Observable<User[]>;
  private pagination = {
    id: 'users_pagination',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0
  };

  private isDesc = true;
  private _errorState: UserListComponent.ErrorState = UserListComponent.ErrorState.None;
  private createUserModalRef: BsModalRef;
  private updateUserModalRef: BsModalRef;
  private _reloadDataSubscription: Subscription = null;

  ngOnInit() {
    this._reloadDataSubscription = this.modalService.onHidden.subscribe(() => this.loadData());
    this.loadPageWithUrlFilterParams();
  }

  ngOnDestroy(): void {
    this._reloadDataSubscription.unsubscribe();
    swal.close();
    
    if (this.createUserModalRef) {
      this.createUserModalRef.hide();
    }

    if(this.updateUserModalRef) {
      this.updateUserModalRef.hide();
    }

  }

  private setItemsPerPage(itemsPerPage: number): void {
    this.setQueryParams({ count: itemsPerPage });
  }

  private setPage(page: number) {
    this.setQueryParams({ page: page });
  }

  private sort(isDesc: boolean) {
    this.setQueryParams(
      {
        isDesc: isDesc
      });
  }

  private loadPageWithUrlFilterParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.isDesc = params['isDesc'] ? JSON.parse(params['isDesc']) : this.isDesc;
      this.pagination.itemsPerPage = params['count'] ? params['count'] : this.pagination.itemsPerPage;
      this.pagination.currentPage = params['page'] ? params['page'] : this.pagination.currentPage;

      this.loadData();
    });
  }

  private loadData() {
    this._errorState = UserListComponent.ErrorState.None;
    // WORKAROUND: без этой строчки изменение поля this._errorState не определяется в разметке
    this._changeDetector.markForCheck();

    let itemsObservable = this._userService.getUsersPerPage(this.isDesc, this.pagination.itemsPerPage, (this.pagination.currentPage - 1) * this.pagination.itemsPerPage)
      .do(res => {
        // если на форме сейчас те элементы, которыми управляет данный Observable
        if (this._users === itemsObservable) {
          this.pagination.totalItems = res.totalCount;
        }
      }, error => {
        if (error.status == 403 || error.status == 404) {
          this.router.navigateByUrl('/pagenotfound');
        } else {
          // если на форме сейчас те элементы, которыми управляет данный Observable
          if (this._users === itemsObservable) {
            this._errorState = UserListComponent.ErrorState.UnknownError;
            // WORKAROUND: без этой строчки изменение поля this._errorState не определяется в разметке
            this._changeDetector.markForCheck();

            swal({
              title: 'Ошибка',
              text: 'Не удалось получить данные о пользователях. Попробуйте снова',
              type: 'error',
              confirmButtonText: 'Попробовать еще раз'
            }, () => {
              this.loadData();
            });
          }
        }
      })
      .map(res => res.items);
    this._users = itemsObservable;
  }


  private setQueryParams(queryParams: object) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        ...this.activatedRoute.snapshot.queryParams,
        ...queryParams
      }
    });
  }

  private deleteUser(user: User) {
    swal({
      title: `Вы действительно хотите удалить пользователя с именем ${user.name}?`,
      text: "Это действие необратимо",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Да",
      cancelButtonText: "Нет",
      closeOnConfirm: true,
      closeOnCancel: true}, isConfirm => {
        if (isConfirm) {
            this._userService.deleteUser(user.id).subscribe(() => {
            this.loadData();
        }, () => {
              swal({
                title: 'Ошибка',
                text: 'Не удалось удалить пользователя.',
                type: 'error',
                confirmButtonText: 'Вернуть к списку'
              }, () => {
                this.loadData();
              });
            })
        }
    });
  }

  private updateUser(userId: number) {
    this._userService.getUser(userId)
      .subscribe(user => {
        this.updateUserModalRef = this.modalService.show(UserUpdateComponent, { class: 'modal-lg', backdrop: 'static', initialState: {userForEdit: user}});
      }, err => {
        swal({
            title: 'Ошибка',
            text: 'Не удалось получить пользователя. Попробуйте снова',
            type: 'error',
            confirmButtonText: 'Попробовать еще раз'
        }, () => {
            this.loadData();
        });
    });

  }

  private createUser() {
    this.createUserModalRef = this.modalService.show(UserCreateComponent, { class: 'modal-lg', backdrop: 'static' });
  }

  private ErrorStateEnum = UserListComponent.ErrorState;
}

export namespace UserListComponent
{
  export enum ErrorState {
    /**
     * Нет ошибок
     */
    None,
    /**
     * Другая ошибка при получении данных с сервера
     */
    UnknownError
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/admin/user/list/user-list.component.ts